/**
 * Shutdown middleware.
 *
 * When graceful shutdown is active, tag every response with `Connection: close`
 * so clients voluntarily drop their keep-alive sockets on the next request.
 * Combined with `server.closeIdleConnections()` in the signal handler, this
 * drains traffic without killing in-flight requests.
 *
 * Ref: https://github.com/orgs/honojs/discussions/3756
 */

import type { MiddlewareHandler } from 'hono'

import { isShuttingDown } from '../lifecycle-state.js'

export const shutdownMiddleware: MiddlewareHandler = async (c, next) => {
  await next()
  if (isShuttingDown()) {
    c.res.headers.set('Connection', 'close')
  }
}
